// Per-device caches that hold one account's own activity (draft caption,
// search history, viewing history) — none of this is cleared automatically
// when the tab closes, so on a shared device, logging out and having a
// different account log in afterward would otherwise leave the next person
// seeing the previous person's unpublished draft and history. Preferences
// like theme/language/cookie-consent aren't included here on purpose —
// those belong to the device, not the account, and should survive a logout.
import {
  UPLOAD_DRAFT_KEY,
  RECENT_SEARCHES_KEY,
  RECENTLY_VIEWED_KEY,
  PROFILE_CACHE_KEY,
  FEED_CACHE_KEY
} from "./storageKeys";

const KEYS_TO_CLEAR = [UPLOAD_DRAFT_KEY, RECENT_SEARCHES_KEY, RECENTLY_VIEWED_KEY, PROFILE_CACHE_KEY, FEED_CACHE_KEY];

export function clearLocalUserData() {
  KEYS_TO_CLEAR.forEach(key => {
    try {
      localStorage.removeItem(key);
    } catch {
      // localStorage unavailable (private mode, etc.) — nothing to clear
    }
  });
}
